import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const DeveloperModal = ({ modal, setModal, developer }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{
				maxWidth: "700px",
				marginTop: "7%",
				width: "100%",
			}}
			className={`developer-modal ${
				AuthData.lang !== "ar" ? "" : "ar-wrapper"
			}`}>
			<ModalBody>
				<div
					className="overflow-hidden m-0 p-0 text-center"
					style={{ direction: "inherit" }}>
					<div className=" p-0 m-0">
						<img src={developer?.media?.path} alt="developer" />
						<p
							dangerouslySetInnerHTML={{
								__html: t("Developer Overview"),
							}}
							className="my-2 text-primary fw-bold modal-title"></p>
						<p className="m-0 text-color text-center font-size-16">
							Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
							nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
							erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
							tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
							consequat. Duis autem vel eum iriure dolor in hendrerit in
							vulputate velit esse
						</p>
						<p
							dangerouslySetInnerHTML={{
								__html: t("Developer Details"),
							}}
							className="my-2 text-primary fw-bold modal-title"></p>
						<div className="developer-num">
							<span>
								{developer?.compounds_count} {t("Compounds")}
							</span>
							<span>
								{developer?.buildings_count} {t("Building")}
							</span>
							<span>
								{developer?.units_count} {t("Property")}
							</span>
						</div>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default DeveloperModal;
